export default (axios) => ({
    getSuppliers: (params) => axios.get('/supplier', { params: { pageSize: 9999, ...params } }).then((_) => _.data),
});
